import { render, staticRenderFns } from "./ForeignerAgreePopup.vue?vue&type=template&id=702506b9&scoped=true&"
import script from "./ForeignerAgreePopup.vue?vue&type=script&lang=js&"
export * from "./ForeignerAgreePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702506b9",
  null
  
)

export default component.exports